import React from 'react';
import styled from 'styled-components';

import { Futura } from '~/styles';

export default function ({ documents, large = false, onClick }) {
  return (
    <Wrapper large={large}>
      <Title>添付資料</Title>
      <Main large={large}>
        <Icon src='/images/document.svg' />
        <Count>{documents.length}</Count>
      </Main>
      {large && (
        <Documents>
          {documents.map((document, index) => (
            <Document target='_blank' href={document.url} key={index}>
              <DocumentIcon src='/images/document-black.svg' />
              <DocumentName>{document.name}</DocumentName>
            </Document>
          ))}
        </Documents>
      )}
      {!large && <SeeMore onClick={onClick}>SEE MORE</SeeMore>}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  height: ${(props) => (props.large ? 'auto' : '235px')};
  background: #fff;
  border-radius: 10px;
  display: flex;
  flex-direction: column;
  position: relative;
`;

const Title = styled.div`
  margin-top: 5px;
  margin-left: 10px;
  font-size: 12px;
  font-weight: bold;
  color: #2c2c2c;
`;

const Main = styled.div`
  margin-top: ${(props) => (props.large ? '15px' : '80px')};
  margin-left: ${(props) => (props.large ? '35px' : 0)};
  display: flex;
  flex-direction: row;
  justify-content: ${(props) => (props.large ? 'flex-start' : 'center')};
  align-items: center;
`;

const Icon = styled.img``;

const Count = styled.div`
  margin-left: 25px;
  font-size: 45px;
`;

const SeeMore = styled(Futura)`
  position: absolute;
  font-size: 15px;
  text-decoration: underline;
  display: block;
  cursor: pointer;
  z-index: 1;
  left: 35px;
  bottom: 10px;
`;

const Documents = styled.div`
  padding: 15px 35px 40px;
`;

const Document = styled.a`
  margin-top: 15px;
  padding: 5px 15px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #ebebeb;
`;

const DocumentIcon = styled.img``;

const DocumentName = styled.div`
  margin-left: 20px;
  font-size: 14px;
  line-height: 25px;
`;
